import { React, useEffect, useState, useContext } from 'react';
import axios from "axios";
import { GlobalLoading, showLoading } from 'react-global-loading';
import { MyContextProvider } from "../../../App";
import { API_URL, getAuthHeaders, getUserClaimsForUi } from '../../../Constant';
import { changeDateFormat, validateRolesIIPManufacturing, getAllYears, getMonthList }
  from "../../../Custom/Custom";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import messages from '../../../assets/Messages.json';
import { generateMonthlyPendencyReport } from '../../../Custom/IIPReport/Report/ReportExcel';
import iipTitleData from '../../../iip.json';


function MonthlyPendencyReport() {
  const currentDate = new Date();
  const currentMonthIndex = currentDate.getMonth();

  const currentYear = currentDate.getFullYear();
  const prevMonthDate = new Date(currentDate);
  prevMonthDate.setMonth(currentDate.getMonth() - 1);
  const prevMonthName = prevMonthDate.toLocaleString('default', { month: 'short' }).toUpperCase();
  const [division, setdivision] = useState([]);
  const [district, setdistrict] = useState([]);
  const [monthName, setMonthName] = useState(prevMonthName);
  const [yearName, setYearName] = useState(currentYear.toString());
  const [divisionList, setDivisionList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [monthlyPendencyReportData, setMonthlyPendencyReportData] = useState([]);
  const [districtName, setdistrictName] = useState([]);
  const [divisionName, setdivisionName] = useState([]);
  const token = useContext(MyContextProvider).token;
  const navigate = useNavigate();
  const decoded = getUserClaimsForUi();
  const userlevelLogin = decoded?.id?.USER_LEVEL_LOCATION;
  const userLevel = decoded?.id?.USER_TYPE;
  const storedLanguage = localStorage.getItem('language');

  const config = getAuthHeaders();


  useEffect(() => {
    const userRole = async () => {
      showLoading(true);
      try {
        const role = await validateRolesIIPManufacturing(decoded);
        if (!role) {
          alert("You are not an authorized for IIP Report");
          navigate("/dashboard");
        }
      } catch (error) {
        console.log(error);
        showLoading(false);
      }
    };

    userRole();

    const fetchDivisionList = async () => {
      try {
        const response = await axios.get(`${API_URL}api/getalldivisionallist`, config);
        const allDivision = response.data;

        if (allDivision.status) {
          setDivisionList(allDivision.data);
        }
      } catch (error) {
        console.error(error);
        showLoading(false);
      } finally {
        showLoading(false);
      }
    };
    fetchDivisionList();
    if (userLevel === "DISTRICT LEVEL") {
      setdistrict(userlevelLogin);
    }
    if (userLevel === "DIVISION LEVEL") {
      handleDivisionChange({ target: { value: userlevelLogin } });
    }
    if (userLevel === "HEAD QUARTER") {
      getallDistrictList();
    }

  }, []);

  // Handle GetDistrict List *********************
  const getallDistrictList = async () => {
    try {
      const response = await axios.get(`${API_URL}api/getallDistrictList`, config);
      const allDistrictsHQ = response.data;
      setDistrictList(allDistrictsHQ.data);
    } catch (error) {
      console.error(error);
    }
  };

  // Handle District On Change ****************
  const handleDistrictChange = (event) => {
    setdistrict(event.target.value);
    const _selectedTextDis = event.target.options[event.target.selectedIndex].text;
    const _districtName = _selectedTextDis === "ALL" ? "" : _selectedTextDis;
    setdistrictName(_districtName);
  };



  // Handle Divison On Change ****************
  const handleDivisionChange = async (event) => {
    const selectedDivision = event.target.value;
    setdivision(selectedDivision);
    setdistrict([]);
    if (selectedDivision) {
      // If division is selected, call the API immediately
      showLoading(true);
      const post_data = {
        division_Id: selectedDivision
      };
      try {
        const response = await axios.post(`${API_URL}api/geDistrictListByDivisionId`, post_data, config);
        const allDistricts = response.data;
        if (allDistricts.status) {
          setDistrictList(allDistricts.data);
          showLoading(false);
        }
      } catch (error) {
        console.error(error);
        showLoading(false);
      }
    } else {

      setDistrictList([]);
    }
  };


  const handleMonthChange = (event) => {
    setMonthName(event.target.value);
  };

  const handleYearChange = (event) => {
    setYearName(event.target.value);
  };


  const handleMonthlyPendencyData = (event) => {
    if (event) event.preventDefault();
    handleGenerateExcel();
  };


  const getNextMonths = (currentMonth) => {
    const monthIndex = new Date(Date.parse(currentMonth + " 1, 2020")).getMonth(); // January is 0
    const nextMonths = [];

    for (let i = 1; i <= 2; i++) {
      const nextMonthIndex = (monthIndex + i) % 12; // Loop back to January if it goes over December
      const monthName = new Date(0, nextMonthIndex).toLocaleString('default', { month: 'short' }).toUpperCase(); // Get month name
      nextMonths.push(monthName);
    }

    return nextMonths;
  };



  const handleGenerateExcel = async () => {
    if (!yearName) {
      toast.error('Please Select Survey Year', messages.COLOR_RED);
      return;
    }

    let modifiedDivision = division;
    let modifiedDistrict = district;

    if (Array.isArray(division) && division.length === 0) {
      modifiedDivision = '';
    }
    if (Array.isArray(district) && district.length === 0) {
      modifiedDistrict = '';
    }

    if (modifiedDivision === '00' || modifiedDistrict === '00') {
      toast.info('Data not found.', messages.COLOR_RED);
      return false;
    }

    const post_data = {
      year: yearName,
      division: modifiedDivision || '',
      district: modifiedDistrict || '',
      month: monthName,
    };

    try {
      showLoading(true);


      const response = await axios.post(`${API_URL}api/iipReports/iiPManufacturingMonthWisePendency`, post_data, config);

      const responseData = response.data.data;
      const monthlist = response.data.data.monthlist;
      const pendencyData = [];
      responseData.GroupCodes.forEach(group => {
        let majorGroupName = group.majorGroupName.split("##");
        const divisionName = majorGroupName[1];
        const districtName = majorGroupName[2];
        const monthData = group.subgroupsdata;
        const subgroup = {
          divisionName: divisionName,
          districtName: districtName,
          monthData: monthData
        };
        pendencyData.push(subgroup);
      });


      downloadReport(pendencyData, monthlist)

    } catch (error) {
      console.error(error);
    } finally {
      showLoading(false);
    }
  };



  //create Row data
  const getMappedData = (item, monthlist) => {
    let result = [];
    for (let i = 0; i < monthlist.length; i++) {
      result.push(
        (typeof item[i]?.pendingIndustry === 'undefined') ? '' : item[i].pendingIndustry,
        (typeof item[i]?.pendinfCount === 'undefined') ? 0 : item[i].pendinfCount,
      )
    }
    return result
  }




  //download sheet data
  const downloadReport = (modifiedData, monthlist) => {

    const transformedData = modifiedData.map(item => [
      item.divisionName,
      item.districtName,
      ...getMappedData(item.monthData, monthlist)
    ]);

    // let endColumn = String.fromCharCode(66 + (monthlist.length * 2));
    function getExcelColumnName(colIndex) {
      let columnName = '';
      while (colIndex >= 0) {
        columnName = String.fromCharCode((colIndex % 26) + 65) + columnName;
        colIndex = Math.floor(colIndex / 26) - 1;
      }
      return columnName;
    }

    let columnCount = 2 + (monthlist.length * 2) - 1;
    let endColumn = getExcelColumnName(columnCount);

    const excelObjectData = {
      fileName: `IIP_PendencyReport__${monthName}_${yearName}`,
      fileType: 'xls',
      sheetName: 'IIPPendencyReport',
      firstRowMergeCells: `A1:${endColumn}1`,
      firstRowExportDate: changeDateFormat(new Date()),
      firstRowCellNumber: 8,
      secondRowMergeCells: `A2:${endColumn}2`,
      secondRowText: 'Index of Industrial Production, Uttar Pradesh',
      thirdRowMergeCells: `A3:${endColumn}3`,
      thirdRowText: 'Monthly Pendency Details',
      fourthRowMergeCells: `A4:${endColumn}4`,
      fourthRowText: '(Manufacturing Sector- Pendency Report)',
      fifthRowMergeCells: `A5:${endColumn}5`,
      fifthRowText: `${monthName}-${yearName}`,
      headerEnglishColumns: [
        'Division Name',
        'District Name',
        ...monthlist.flatMap(month => [`${month}`, '']),
      ],
      monthlist: monthlist,
      columnCount: columnCount,
      headerEnglishColumns1: [
        '', '', ...monthlist.flatMap(() => ['Pending Industry', 'Count']),
      ],
      getExcelColumnName,
    };
    excelObjectData.excelRowData = transformedData;
    generateMonthlyPendencyReport(excelObjectData);

  }

  // const isYearRestricted = (year) => {
  //   return year === currentYear || year === currentYear + 1;
  // };

  // const monthOptions = getMonthList().map((month, index) => {
  //   const isDisabled = isYearRestricted(yearName) && index > currentMonthIndex;
  //   return (
  //     <option key={month.value} value={month.value} disabled={isDisabled}>
  //       {month.label}
  //     </option>
  //   );
  // });

  // Define the month options based on selected year
  const monthOptions = () => {
    const months = getMonthList();
    if (yearName === currentYear.toString()) {
      // If the selected year is the current year, limit to current month
      return months.slice(0, currentMonthIndex + 1);
    }
    return months; // For other years, return all months
  };


  return (
    <>
      <ToastContainer />
      <GlobalLoading />
      <div className="container-fluid py-3">
        <div className="card mx-3 mb-3">
          <div className="card-body pb-1">
            <div className="row align-items-center">
              <h4 className="page_heading">
                <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? iipTitleData.hi.MONTHLY_PENDENCY_REPORT : iipTitleData.en.MONTHLY_PENDENCY_REPORT }} />
              </h4>

              {userLevel === "HEAD QUARTER" && (
                <>
                  <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                    <label>Division</label>
                    <select value={division} onChange={handleDivisionChange} name="division" className="form-select">
                      <option value="">ALL</option>
                      {divisionList.length > 0 && divisionList.map((ele, index) => (
                        <option key={ele.DIVISION_NAME} value={ele.DIVISION_CODE}>
                          {ele.DIVISION_CODE}{'-'}{ele.DIVISION_NAME}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                    <label>District</label>

                    <select value={district} onChange={handleDistrictChange} name="district" className="form-select">
                      <option value="">ALL</option>
                      {districtList.map((ele, index) => (
                        <option key={ele.DISTRICT_CODE} value={ele.DISTRICT_CODE}>
                          {ele.DISTRICT_CODE}{'-'}{ele.DISTRICT_NAME}
                        </option>
                      ))}
                    </select>


                  </div>
                </>
              )}


              {userLevel === "DIVISION LEVEL" && (
                <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                  <label>District</label>

                  <select value={division} onChange={handleDivisionChange} name="division" className="form-select">
                    <option value="">ALL</option>
                    {divisionList.length > 0 && divisionList.map((ele, index) => (
                      <option key={ele.DIVISION_CODE} value={ele.DIVISION_CODE}>
                        {ele.DIVISION_CODE}{'-'}{ele.DIVISION_NAME}
                      </option>
                    ))}
                  </select>


                </div>
              )}

              <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                <label>Month</label>
                {/* <select value={monthName} onChange={handleMonthChange} name="month" className="form-select">
                  <option value="" >Select Month</option>
                  {getMonthList().map((month) => (
                    <option key={month.value} value={month.value}>{month.label}</option>
                  ))}
                </select> */}

                <select value={monthName} onChange={handleMonthChange} name="month" className="form-select">
                  <option value="">Select Month</option>
                  {monthOptions().map((month) => (
                    <option key={month.value} value={month.value}>{month.label}</option>
                  ))}
                </select>

              </div>

              <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                <label>Year</label>
                <select value={yearName} onChange={handleYearChange} name="surveyYear" className="form-select">
                  <option value="">Select Year</option>
                  {getAllYears().map((year, index) => (
                    <option key={year} value={year}>{year}</option>
                  ))
                  }
                </select>
              </div>



              <div className="col-xl-2 col-lg-12 mb-3">
                <label className="w-100 d-none d-sm-block">&nbsp;</label>
                <button onClick={handleMonthlyPendencyData} type="submit" className="btn btn_orange">Search</button>
              </div>


            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default MonthlyPendencyReport